import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { ActiveTicketsList, Button, Modal } from '../../components'
import { IStoreState } from '../../store/states'
import { connectRedux } from '../../helpers/connectRedux'
import { IPublicTicket, IServiceInfo } from '../../models'
import { LiteralsService } from '../../services'
import { images } from '../../images'
import { setDisplayedActiveTicketsAction, setIsAlterationsModalOpenAction } from '../../store/actions'
import StyledDiv from './styles'

interface IProps extends DispatchProp<any> {
  isAlterationModalOpen: boolean
  displayedActiveTickets: IPublicTicket[] | null
  serviceInfos: IServiceInfo[] | null
}

class AlterationModal extends PureComponent<IProps> {
  private get alterationsContent(): ReactNode {
    const { serviceInfos } = this.props

    const serviceInfosWithAlterationMessages = serviceInfos?.filter((serviceInfo) => serviceInfo.alterationMessages.length > 0)

    if (!serviceInfosWithAlterationMessages?.length) return null

    return (
      <div className="content">
        {
          serviceInfosWithAlterationMessages.map((serviceInfo, index) => (
            <div className="alteration" key={ `service-alteration-${ index }` }>
              <span className="service-name">
                { serviceInfo.name }
              </span>
              {
                serviceInfo.alterationMessages.map((message, alterationIndex) => (
                  <span key={ `message-${ alterationIndex }` } className="alteration-text">
                    { message }
                  </span>
                ))
              }
              {
                index < (serviceInfosWithAlterationMessages.length - 1) &&
                <div className="divider"></div>
              }
            </div>
          ))
        }
      </div>
    )
  }

  public render(): ReactNode {
    const { isAlterationModalOpen, displayedActiveTickets } = this.props

    if (displayedActiveTickets) {
      return this.modal(
        images.activeTicket,
        LiteralsService.get('activeTickets.title', true),
        <div className="content">
          <ActiveTicketsList tickets={ displayedActiveTickets } />
        </div>
      )
    }

    if (!isAlterationModalOpen) return null
    return this.modal(images.alteration, LiteralsService.get('alterations.title', true), this.alterationsContent)
  }

  private modal(icon: string, title: string, content: ReactNode): ReactNode {
    return (
      <Modal isHidden={ false } onOverlayClick={ this.handleClose }>
        <StyledDiv>
          <header className="vertical">
            <img src={ icon } alt="" aria-hidden="true" />
            <span>{ title }</span>
          </header>
          { content }
          <footer>
            <Button
              title={ LiteralsService.get('understood') }
              onPress={ this.handleClose }
              upper
              filled
            />
          </footer>
        </StyledDiv>
      </Modal>
    )
  }

  private handleClose = () => {
    const { dispatch, displayedActiveTickets } = this.props

    if (displayedActiveTickets) dispatch(setDisplayedActiveTicketsAction(null))
    else dispatch(setIsAlterationsModalOpenAction(false))
  }
}

const mapStateToProps = ({ newReservation, alterations }: IStoreState) => ({
  isAlterationModalOpen: alterations.isAlterationsModalOpen,
  displayedActiveTickets: alterations.displayedActiveTickets,
  serviceInfos: newReservation.serviceInfos
})

export default connectRedux(mapStateToProps, AlterationModal)
